type SortableItem<T> = T & { rank: number };

/**
 * Sort an array of object that have a rank property
 * @param sortableList List of sortableItems
 * @returns sortedList List sorted by rank
 */
export const sortByRank = <T>(sortableList: SortableItem<T>[]): SortableItem<T>[] =>
    sortableList.sort((a, b) => a.rank - b.rank);
